import './VerticalOption.scss'

import React from 'react'

export default function VerticalOption({
  title,
  backgroundImage,
  onClick,
  landerId,
}) {
  const verticalOverlayClassName = `BackgroundOverlay12 version${landerId}`
  return (
    <div
      className="VerticalOption12"
      onClick={onClick}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className={verticalOverlayClassName}></div>
      <span>{title}</span>
    </div>
  )
}
